import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Palette } from "lucide-react";

const LINKS = [
  { href: "#meera", label: "Meera Series" },
  { href: "#playful", label: "Playful World" },
  { href: "#bookshelf", label: "Bookshelf" },
  { href: "#articles", label: "Articles" },
  { href: "#public-work", label: "Public Work" },
  { href: "#music", label: "Music" },
  { href: "#about", label: "About" },
  { href: "#journey", label: "Journey" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // Mount-only scroll listener; setScrolled is stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F9F6F0]/85 backdrop-blur-xl border-b border-[#E5DFD3]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display text-xl sm:text-2xl text-[#1E2A4F] tracking-tight leading-none"
        >
          <span className="text-[#D95D39] text-sm not-italic">Dr.</span> Divya<span className="text-[#D95D39]"> .</span>
          <span className="block text-[10px] uppercase tracking-[0.24em] text-[#5C6A8F] mt-0.5">
            Ramachandran
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="ink-link text-sm text-[#1E2A4F]/80 hover:text-[#1E2A4F] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/studio"
            data-testid="nav-link-studio"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#D95D39] text-[#F9F6F0] text-sm hover:bg-[#1E2A4F] transition-colors duration-500"
          >
            <Palette size={14} /> Art Studio
          </Link>
        </nav>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 inline-flex items-center justify-center rounded-full border border-[#E5DFD3] text-[#1E2A4F]"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E5DFD3] bg-[#F9F6F0]/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.href.slice(1)}`}
                className="py-2 text-[#1E2A4F] text-base"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/studio"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-link-studio"
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-[#D95D39] text-[#F9F6F0] text-sm"
            >
              <Palette size={14} /> Try the Art Studio
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
